import { Box } from '@mui/material';
import React from 'react';
import ElementDataRow from 'components/common/element-data/ElementDataRow';
import { ElementMetadataFieldName, IElementDataDrillDown } from 'components/common/element-data/types';
import { buildDrillToURL } from 'components/element-viewer';
import { getFieldElementMetadataSettings } from 'components/common/element-data/functions';

export default function DrillDown(props: IElementDataDrillDown) {
    const { drillDown = [], settings } = props;
    const fieldKey: ElementMetadataFieldName = 'drill_down';
    const { fieldMetadataDisplay, fieldMetadataOrder } = getFieldElementMetadataSettings(settings, fieldKey);

    if (!fieldMetadataDisplay || drillDown.length == 0) return null;

    return (
        <ElementDataRow order={fieldMetadataOrder}>
            {drillDown.map((drillItem) => (
                <Box key={drillItem.drillId}>
                    <Box
                        component="a"
                        className={'default-link'}
                        href={buildDrillToURL(drillItem)}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {drillItem.label}
                    </Box>
                </Box>
            ))}
        </ElementDataRow>
    );
}
